"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const Wrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-direction: column;
  height: 85%;
  justify-content: center;
  padding: 0 20px;

  h3,
  p {
    text-align: center;
  }

  h3 {
    font-size: 4vmin;
    font-weight: 400;
    margin-top: 4vmin;
    margin-bottom: 2vmin;
  }

  p {
    margin-top: 0px;
    margin-bottom: 5vmin;
    font-size: 3vmin;
  }

  img {
    display: block;
    margin: 0 auto;
    height: 7vmin;
  }
`;
const ButtonWrapper = styled_components_1.default.div `
  margin: 0 auto;

  button {
    width: 40vmin;
    margin: 2vmin;
    font-size: 2.2vmin;
  }
`;
const CardActivationFailed = ({ statusData, baseUrl, history }) => {
    if (!statusData) {
        return null;
    }
    const { texts } = statusData;
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement("img", { src: "/images/other/exclamationMark.jpeg", alt: "activation-success" }),
        texts && texts.headline && react_1.default.createElement("h3", null, texts.headline),
        texts && texts.text && react_1.default.createElement("p", null, texts.text),
        react_1.default.createElement(ButtonWrapper, null, texts && texts.tryAgainButton && (react_1.default.createElement(material_1.Button, { fullWidth: true, variant: "contained", size: "large", onClick: () => {
                history.push(`${baseUrl}/guest_journey/kiosk/keycard_activation_flow/activate_card`);
            } },
            " ",
            texts.tryAgainButton)))));
};
const mapStoreToProps = (store) => ({
    baseUrl: store.getValue("baseUrl"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(CardActivationFailed));
